module.exports = __webpack_public_path__ + "04_bob_gray.16585cec.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/04_bob_gray.png
// module id = swlA
// module chunks = 0